"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* global paginationController */
var categoryArticleList = function categoryArticleList() {
  var breakpoint = 992;

  // This is a constructor used for building the category list
  function _categoryList(_target, categoryID, renderingName, renderingTemplateId, pageSize, totalArticles, page, paginate) {
    //check for a valid target first
    var categoryListTarget = this.getTarget(_target);
    if (!categoryListTarget) {
      return;
    }

    //initial set up and values
    this.target = categoryListTarget;
    this.categoryID = categoryID;
    this.pageSize = pageSize;
    this.totalArticles = totalArticles;
    this.page = page;
    this.paginate = paginate;
    this.pagination = null;
    this.isMobile = this.isViewportMobile();
    this.renderingName = renderingName;
    this.renderingTemplateId = renderingTemplateId;
    this.api = this.getApiUrl();

    // find the group body class, clone the first child, and set it to an empty string
    this.categoryListCardGroupBody = this.target.querySelector(".card-group-body");
    if (this.categoryListCardGroupBody) {
      var cardtemplatecard = this.categoryListCardGroupBody.querySelector("*:first-child");
      if (cardtemplatecard) {
        this.cardTemplate = cardtemplatecard.cloneNode(true);
      }
      this.categoryListCardGroupBody.innerHTML = '';
    }
  }

  //Return a valid target
  _categoryList.prototype.getTarget = function (target) {
    var categoryListTarget = document.getElementById(target);

    //First, check to see if the target is either null or undefined
    if (categoryListTarget === null || categoryListTarget === undefined) {
      //If the target is undefined = look for one on the page and use it.
      categoryListTarget = document.querySelector("[data-rendering='Category Article List']");

      //Still can't find it - time to bail
      if (categoryListTarget === null || categoryListTarget === undefined) {
        return false;
      }
    }
    return categoryListTarget;
  };

  //Create the article cards
  _categoryList.prototype.createCards = function (data) {
    //clear existing cards first
    this.categoryListCardGroupBody.innerHTML = '';
    if (this.cardTemplate) {
      for (var article = 0; article < data.length; article++) {
        var newCard = this.cardTemplate.cloneNode(true);

        //article title
        newCard.querySelector(".card-content a").href = data[article].ArticleLink;

        //article link
        newCard.querySelector(".card-content a").innerText = data[article].Title;

        //Card Body
        var cardtext = newCard.querySelector(".card-content .card-text");
        cardtext.innerHTML = "";

        //insert byline before article summary
        cardtext.innerHTML = data[article].Byline;

        //summary
        var summarytextnode = document.createElement("p");
        var summarytext = data[article].ArticleSummary;
        if (summarytext) {
          summarytextnode.innerHTML = summarytext;
          cardtext.appendChild(summarytextnode);
        }

        //append the card to the cardgroup
        this.categoryListCardGroupBody.appendChild(newCard);
      }
    }

    //instantiate the pagination object if paging
    this.createPagination();
  };

  //Add pagination - create the pagination object for this control
  _categoryList.prototype.createPagination = function () {
    if (this.paginate && this.pagination === null) {
      if (typeof pagination === "undefined") {
        window.pagination = new paginationController();
      }
      this.pagination = window.pagination.init(this.target, this.totalArticles, this.pageSize, this.page);

      //let the pagination object know what it is controlling (this)
      this.pagination.pageObj = this;
    }
  };

  //Build the api url
  _categoryList.prototype.getApiUrl = function () {
    return '/api/article/GetArticlesByCategory/' + this.categoryID + '/' + this.renderingName + '/' + this.renderingTemplateId + '/' + this.pageSize + '/' + this.page;
  };
  _categoryList.prototype.isViewportMobile = function () {
    if (window.innerWidth < breakpoint) {
      return true;
    }
    return false;
  };

  // Function to fetch api
  _categoryList.prototype.callApi = function () {
    var _this = this;
    fetch(this.api, {
      method: 'GET',
      mode: 'same-origin',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data && data.length > 0) {
        _this.createCards(data);
      }
    }).catch(function () {
      //failed request
    });
    return true;
  };

  //This is the call back from the pagination
  _categoryList.prototype.getPage = function (pageNumber, _obj) {
    //_obj is the original _categoryList object
    var _coords = _obj.target.getBoundingClientRect();
    var _viewportoffset = document.documentElement.scrollTop;
    var _scrollTo = _viewportoffset + _coords.y;
    var topoffset = document.querySelector("header").offsetHeight;
    _scrollTo = _scrollTo - topoffset;
    if (typeof _scrollTo === "number") {
      window.scrollTo({
        top: _scrollTo,
        left: 0,
        behavior: "smooth"
      });
    }
    try {
      _obj.page = pageNumber - 1;
      _obj.api = _obj.getApiUrl();
      _obj.callApi();
    } catch (e) {
      //error do nothing
    }
  };
  function _init(target, categoryID, renderingName, renderingTemplateId, pageSize, totalArticles, page, paginate) {
    var categoryListItem = new _categoryList(target, categoryID, renderingName, renderingTemplateId, pageSize, totalArticles, page, paginate);

    //call the api and get the data
    categoryListItem.callApi();
  }
  return {
    init: _init
  };
};
if (typeof exports !== 'undefined') {
  module.exports = categoryArticleList;
}
// JavaScript source code
var exploreMoreFeedList = function exploreMoreFeedList() {
  // This is a constructor used for building the category list
  function _exploreMoreFeed(_target, categoryID, renderingName, renderingTemplateId, totalArticles) {
    //check for a valid target first
    var exploreMoreFeedTarget = this.getTarget(_target);
    if (!exploreMoreFeedTarget) {
      return;
    }

    //initial set up and values
    this.target = exploreMoreFeedTarget;
    this.categoryID = categoryID;
    this.totalArticles = totalArticles;
    this.renderingName = renderingName;
    this.api = this.getApiUrl();
    this.renderingTemplateId = renderingTemplateId;

    // find the group body class, clone the first child, and set it to an empty string
    this.exploreMoreFeedCardGroupBody = this.target.querySelector(".card-group-body");
    this.firstArticleCardHolder = this.exploreMoreFeedCardGroupBody.querySelector('.tab-panel:not([hidden]) .emf-first');
    this.cardTemplate = this.firstArticleCardHolder.querySelector("*:first-child");
    this.restArticleCardHolder = this.exploreMoreFeedCardGroupBody.querySelector('.tab-panel:not([hidden]) .emf-rest');
    this.categoryPageLinkTemplate = this.exploreMoreFeedCardGroupBody.querySelector('.tab-panel:not([hidden]) .category-link-content');
    var cardImage = this.cardTemplate.querySelector(".card-media img");
    if (!cardImage) {
      cardImage = this.getCardMediaImageTemplate();
      this.cardTemplate.querySelector("div.card-body div.row.no-gutters div.col").prepend(cardImage);
    }
  }

  //get card media image template for cases where the first article has no image
  _exploreMoreFeed.prototype.getCardMediaImageTemplate = function () {
    var cardMediaDiv = document.createElement("div");
    cardMediaDiv.className = "card-media";
    var cardImage = document.createElement("img");
    cardImage.className = "card-img img-background";
    cardMediaDiv.appendChild(cardImage);
    return cardMediaDiv;
  };

  //Return a valid target
  _exploreMoreFeed.prototype.getTarget = function (target) {
    var exploreMoreFeedTarget = document.getElementById(target);

    //First, check to see if the target is either null or undefined
    if (exploreMoreFeedTarget === null || exploreMoreFeedTarget === undefined) {
      //If the target is undefined = look for one on the page and use it.
      exploreMoreFeedTarget = document.querySelector("[data-rendering='Explore More Feed']");

      //Still can't find it - time to bail
      if (exploreMoreFeedTarget === null || exploreMoreFeedTarget === undefined) {
        return false;
      }
    }
    return exploreMoreFeedTarget;
  };

  //Create the article cards
  _exploreMoreFeed.prototype.createCards = function (data) {
    //clear existing cards first
    this.firstArticleCardHolder.innerHTML = '';
    this.restArticleCardHolder.innerHTML = '';
    if (this.cardTemplate) {
      //set holders to new tab-panel
      this.firstArticleCardHolder = this.exploreMoreFeedCardGroupBody.querySelector("[id='nav-".concat(this.categoryID, "-tab'] .emf-first"));
      this.restArticleCardHolder = this.exploreMoreFeedCardGroupBody.querySelector("[id='nav-".concat(this.categoryID, "-tab'] .emf-rest"));
      for (var article = 0; article < data.Articles.length; article++) {
        var newCard = this.cardTemplate.cloneNode(true);

        //article image
        var cardImage = newCard.querySelector(".card-media img");
        if (data.Articles[article].ArticleImage) {
          cardImage.src = data.Articles[article].ArticleImage.URL;
          cardImage.height = data.Articles[article].ArticleImage.Height;
          cardImage.width = data.Articles[article].ArticleImage.Width;
          cardImage.alt = data.Articles[article].ArticleImage.AltText;
        }

        //article title
        newCard.querySelector(".card-content a").href = data.Articles[article].ArticleLink;

        //article link
        newCard.querySelector(".card-content a").innerText = data.Articles[article].Title;

        //Card Body
        var cardtext = newCard.querySelector(".card-content .card-text");
        cardtext.innerHTML = "";

        //insert byline before article summary
        cardtext.innerHTML = data.Articles[article].Byline;

        //summary
        var summarytextnode = document.createElement("p");
        var summarytext = data.Articles[article].ArticleSummary;
        if (summarytext) {
          summarytextnode.innerHTML = summarytext;
          cardtext.appendChild(summarytextnode);
        }

        //append the card to the cardgroup
        if (article === 0) {
          this.firstArticleCardHolder.appendChild(newCard);
        } else {
          this.restArticleCardHolder.appendChild(newCard);
        }
      }

      //update explore more category link
      var categoryLink = this.categoryPageLinkTemplate.querySelector(".card-text a");
      categoryLink.href = data.Category.CategoryPageURL;
      categoryLink.innerHTML = 'View All ' + data.Category.Title + ' Content';
      this.restArticleCardHolder.appendChild(this.categoryPageLinkTemplate);
    }
  };

  //Build the api url
  _exploreMoreFeed.prototype.getApiUrl = function () {
    return '/api/article/GetArticlesAndCategoryByCategory/' + this.categoryID + '/' + this.renderingName + '/' + this.renderingTemplateId + '/' + this.totalArticles;
  };

  // Function to fetch api
  _exploreMoreFeed.prototype.callApi = function () {
    var _this2 = this;
    fetch(this.api, {
      method: 'GET',
      mode: 'same-origin',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data && data.Articles && data.Articles.length > 0) {
        _this2.createCards(data);
      }
    }).catch(function () {
      //failed request
    });
    return true;
  };
  _exploreMoreFeed.prototype.swapCategory = function (categoryID) {
    //create exploreMoreFeedItem with new category
    this.categoryID = categoryID;
    this.api = this.getApiUrl();

    //call article service api and create cards
    this.callApi();
  };
  _exploreMoreFeed.prototype.onCategoryClick = function (category) {
    //get category id for category that was clicked
    var categoryId = category.getAttribute("data-id");
    if (this.categoryID !== categoryId) {
      //get new articles and swap with current articles
      this.swapCategory(categoryId);

      //get active category
      var activeCategory = document.getElementsByClassName('article-category-link active')[0];

      //swap 'active' class to active category
      activeCategory.classList.remove("active");
      category.classList.add("active");

      //update aria-selected
      activeCategory.setAttribute('aria-selected', 'false');
      category.setAttribute('aria-selected', 'true');

      //swap tab panels
      var currentPanel = document.querySelector('.tab-panel:not([hidden])');
      currentPanel.setAttribute('hidden', 'hidden');
      var selectedPanel = document.getElementById('nav-' + this.categoryID + '-tab');
      selectedPanel.removeAttribute('hidden');

      //set tabindex to 0 on active category
      activeCategory.removeAttribute('tabindex');
      category.setAttribute('tabindex', '0');
    }
  };
  _exploreMoreFeed.prototype.onWindowKeyUp = function (key, previousFocusedElement) {
    if (!document.activeElement.classList.contains('article-category-link')) {
      return;
    }
    var activeCategory = document.querySelector('.article-category-link.active');
    if (key.code === 'Tab') {
      var noIndexAt = -1;
      if (!previousFocusedElement.id || previousFocusedElement.id.indexOf('nav-') === noIndexAt) {
        activeCategory.focus();
      } else if (activeCategory.id !== document.activeElement.id) {
        document.querySelector('.emf-first .card-content a').focus();
      }
    } else if (key.code === 'ArrowUp') {
      var previousSibling = activeCategory.parentElement.previousElementSibling;
      if (previousSibling) {
        var focusedElement = previousSibling.querySelector('button');
        this.onCategoryClick(focusedElement);
        focusedElement.focus();
      } else {
        var totalCategories = document.getElementsByClassName('article-category-link');
        var lastElement = totalCategories[totalCategories.length - 1];
        this.onCategoryClick(lastElement);
        lastElement.focus();
      }
    } else if (key.code === 'ArrowDown') {
      var nextSibling = activeCategory.parentElement.nextElementSibling;
      if (nextSibling) {
        var _focusedElement = nextSibling.querySelector('button');
        this.onCategoryClick(_focusedElement);
        _focusedElement.focus();
      } else {
        var firstElement = document.getElementsByClassName('article-category-link')[0];
        this.onCategoryClick(firstElement);
        firstElement.focus();
      }
    }
  };
  function _init(target, categoryID, rendering, renderingTemplateId, totalArticles) {
    var exploreMoreFeed = new _exploreMoreFeed(target, categoryID, rendering, renderingTemplateId, totalArticles);
    Array.from(document.getElementsByClassName("article-category-link")).forEach(function (category) {
      //set onclick event for each category
      category.onclick = function (e) {
        e.preventDefault();
        exploreMoreFeed.onCategoryClick(category);
      };
      var previousFocusedElement = document.activeElement;

      //prevent arrow key page scrolling if on a category button
      window.onkeydown = function (key) {
        if (document.activeElement.classList.contains('article-category-link') && (key.code === 'ArrowUp' || key.code === 'ArrowDown')) {
          key.preventDefault();
        }
        previousFocusedElement = document.activeElement;
      };

      //aria tab focusing logic
      window.onkeyup = function (key) {
        exploreMoreFeed.onWindowKeyUp(key, previousFocusedElement);
      };
    });
  }
  return {
    init: _init
  };
};
if (typeof exports !== 'undefined') {
  module.exports = exploreMoreFeedList;
}
var paginationController = function paginationController() {
  var breakpoint = 992;
  var pagePadding = 3;
  var maxNumberOfPages = 6;
  function _pagination(paginationTarget, totalNumberArticles, pageSize, currentPage) {
    //initial set up and values
    this.target = paginationTarget;
    this.totalNumberArticles = totalNumberArticles;
    this.pageSize = pageSize;
    this.currentPage = currentPage + 1;
    this.pages = this.getNumberOfPages();
    this.pageObj = null; // set in object calling pager

    // find the group body class, clone the first child, and set it to an empty string
    this.paginationControl = this.target.querySelector(".pagination");
    this.pageLinkTemplate = this.paginationControl.querySelector("*:first-child").cloneNode(true);
    this.paginationControl.innerHTML = '';
    this.isMobile = this.isViewportMobile();
    return this;
  }

  //add the pagination to the page
  _pagination.prototype.addPagination = function () {
    //clear out old pager if there
    this.paginationControl.innerHTML = '';

    //add the navigation buttons/links
    this.addPreviousLink();
    this.addPages();
    this.nextLink();
    this.closeMenuOnClickOutside();
  };

  //previous link
  _pagination.prototype.addPreviousLink = function () {
    var linkText = "Prev";
    var ariaLabel = "Previous";
    var isDisabled = false;
    var isActive = false;
    if (this.currentPage === 1) {
      isDisabled = true;
    }
    this.buildLink(linkText, isDisabled, isActive, ariaLabel);
  };

  //add numbered pages and dots
  _pagination.prototype.addPages = function () {
    var ariaLabel = "";
    var isDisabled = false;
    var startNumber = 2;
    var endNumber = this.pages;
    var numberedPages = [];
    var startDottedPages = [];
    var endDottedPages = [];
    if (this.isMobile) {
      for (var i = startNumber; i < endNumber; i++) {
        if (i === this.currentPage) {
          // pagenumber, label
          numberedPages.push(i);
        } else {
          endDottedPages.push(i);
        }
      }
    } else {
      for (var _i = startNumber; _i < endNumber; _i++) {
        if (_i < this.currentPage - pagePadding) {
          //not a numbered page
          startDottedPages.push(_i);
        } else if (_i > this.currentPage + pagePadding) {
          //not a numbered page
          endDottedPages.push(_i);
        } else if (_i === this.currentPage) {
          // pagenumber, label
          numberedPages.push(_i);
        } else {
          //it's a numbered page
          numberedPages.push(_i);
        }
      }

      //add upto maxNumberOfPages numberded links
      for (var p = numberedPages.length; p < maxNumberOfPages; p++) {
        if (startDottedPages.length > 0) {
          var itemIndex = startDottedPages.length - 1;
          var moveToNumbered = startDottedPages[itemIndex];
          startDottedPages.pop();
          numberedPages.unshift(moveToNumbered);
        }
        if (numberedPages.length < maxNumberOfPages && endDottedPages.length > 0) {
          var _moveToNumbered = endDottedPages[0];
          endDottedPages.shift();
          numberedPages.push(_moveToNumbered);
        }
      }
    }

    //this is the first link - page 1
    this.buildLink("1", isDisabled, this.currentPage === 1, ariaLabel);

    //first set of ...
    if (startDottedPages.length > 0) {
      this.buildDottedLinkMenu(startDottedPages);
    }
    //links for numbered nav items
    for (var _page in numberedPages) {
      this.buildLink(numberedPages[_page], isDisabled, numberedPages[_page] === this.currentPage, ariaLabel);
    }

    //last set of ...
    if (endDottedPages.length > 0) {
      this.buildDottedLinkMenu(endDottedPages);
    }

    //last page link
    if (endNumber > 1) {
      this.buildLink(endNumber, isDisabled, this.currentPage === endNumber, ariaLabel);
    }
  };

  //next link
  _pagination.prototype.nextLink = function () {
    //next link
    var linkText = "Next";
    var ariaLabel = "Next";
    var isDisabled = false;
    var isActive = false;
    if (this.currentPage >= this.pages) {
      isDisabled = true;
    }
    this.buildLink(linkText, isDisabled, isActive, ariaLabel);
  };

  //build the ... link and the hidden menu behind it
  _pagination.prototype.buildDottedLinkMenu = function (dottedPages) {
    //build Navigation Link
    var that = this;
    var _navItem = this.pageLinkTemplate.cloneNode(true);
    _navItem.classList.add("dropdown");
    var _navLink = _navItem.querySelector("a");
    _navLink.innerText = "...";
    var _arialabel = "Additional navigation options are available once clicked";

    //create the hidden nav list
    var _hiddenMenu = document.createElement("div");
    _hiddenMenu.classList.add("dropdown-menu");
    _navLink.setAttribute("aria-label", _arialabel);
    _navLink.setAttribute("aria-haspopup", "true");
    _navLink.setAttribute("aria-expanded", "false");
    var _loop = function _loop(_page) {
      //create the link for the hidden page
      var _hiddenMenuLink = document.createElement("a");
      _hiddenMenuLink.innerText = dottedPages[_page];
      _hiddenMenuLink.href = "#";
      _hiddenMenuLink.classList.add("dropdown-item");

      //add the link to the menu
      _hiddenMenu.appendChild(_hiddenMenuLink);

      //add click event (paging) to hidden menu link
      _hiddenMenuLink.addEventListener("click", function (e) {
        e.preventDefault();

        //add 1 to the current page the
        that.currentPage = Number(dottedPages[_page]);

        //call the getPage function for the pageObj, send the object so it has the correct context
        if (that.pageObj !== null) {
          that.pageObj.getPage(that.currentPage, that.pageObj);
        }

        //update pagination
        that.addPagination();
      });
    };
    for (var _page in dottedPages) {
      _loop(_page);
    }

    //add hidden menu to the pagination nav item
    _navItem.appendChild(_hiddenMenu);

    //add the nav item to the pagination control
    this.paginationControl.appendChild(_navItem);

    //add the click event for the "..." to show/hide the dropdown menu
    _navLink.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (_navLink.classList.contains("show")) {
        _navLink.classList.remove("show");
        _hiddenMenu.classList.remove("show");
        _navItem.classList.remove("dropup");
        _navLink.setAttribute("aria-expanded", "false");
      } else {
        _navLink.classList.add("show");
        _hiddenMenu.classList.add("show");
        var viewport = _hiddenMenu.getBoundingClientRect();
        var minspace = window.innerHeight - 1;
        if (viewport.bottom > minspace) {
          _navItem.classList.add("dropup");
        }
        _navLink.setAttribute("aria-expanded", "true");
      }
    });
    _navLink.addEventListener('keydown', function (e) {
      var validKeys = ['Spacebar', 'Space', ' ', 'Enter'];
      if (validKeys.indexOf(e.key) >= 0 || validKeys.indexOf(e.code) >= 0) {
        e.preventDefault();
        _navLink.click();
      }
    });
  };

  //build links (but not the ... links)
  _pagination.prototype.buildLink = function (linkText, isDisabled, isActive, ariaLabel) {
    //build Navigation Link
    var _navItem = this.pageLinkTemplate.cloneNode(true);
    var _navLink = _navItem.querySelector("a");
    _navLink.innerText = linkText;

    //make sure we can access the correct (pagination) object
    var that = this;
    if (isDisabled) {
      _navItem.classList.add("disabled");
      _navLink.setAttribute("tabindex", "-1");
      _navLink.setAttribute("aria-disabled", "true");
    }
    if (isActive) {
      _navItem.classList.add("active");
      _navLink.setAttribute("tabindex", "-1");
      _navLink.setAttribute("aria-current", "page");
      var srOnly = document.createElement("span");
      srOnly.classList.add("sr-only");
      srOnly.innerText = "(current)";
      _navLink.appendChild(srOnly);
    }
    if (ariaLabel) {
      _navLink.setAttribute("aria-label", ariaLabel);
    }
    if (linkText === "Next" && !isDisabled) {
      _navLink.addEventListener("click", function (e) {
        e.preventDefault();

        // the api page starts with 0, not 1.  So subtract 1 to get the page we want
        //that.currentPage--;

        //add 1 to the current page the
        that.currentPage++;

        //call the getPage function for the pageObj, send the object so it has the correct context
        if (that.pageObj !== null) {
          that.pageObj.getPage(that.currentPage, that.pageObj);
        }

        //update pagination
        that.addPagination();
      });
    } else if (linkText === "Prev" && !isDisabled) {
      _navLink.addEventListener("click", function (e) {
        e.preventDefault();

        //add 1 to the current page the
        that.currentPage--;

        //call the getPage function for the pageObj, send the object so it has the correct context
        if (that.pageObj !== null) {
          that.pageObj.getPage(that.currentPage, that.pageObj);
        }

        //update pagination
        that.addPagination();
      });
    } else {
      _navLink.addEventListener("click", function (e) {
        e.preventDefault();

        //add 1 to the current page the
        that.currentPage = Number(linkText);

        //call the getPage function for the pageObj, send the object so it has the correct context
        if (that.pageObj !== null) {
          that.pageObj.getPage(that.currentPage, that.pageObj);
        }

        //update pagination
        that.addPagination();
      });
    }
    _navLink.addEventListener("focus", function () {
      that.closeDotMenus();
    });
    this.paginationControl.appendChild(_navItem);
  };

  //close the ... drop down menu when open, if open, when the menu is not clicked
  _pagination.prototype.closeMenuOnClickOutside = function () {
    var that = this;
    document.addEventListener('click', function () {
      that.closeDotMenus();
    });
  };

  //Close the dropdown menu we call the close menu from a few places so created a function for it.
  _pagination.prototype.closeDotMenus = function () {
    var dropdowns = this.paginationControl.querySelectorAll('.dropdown-menu.show');
    if (dropdowns) {
      var _iterator = _createForOfIteratorHelper(dropdowns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _hiddenMenu = _step.value;
          var _navItem = _hiddenMenu.closest("li.page-item");
          var _navLink = _navItem.querySelector("a.page-link");
          _navLink.classList.remove("show");
          _hiddenMenu.classList.remove("show");
          _navItem.classList.remove("dropup");
          _navLink.setAttribute("aria-expanded", "false");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };

  //calculate the number of pages based on the total number of articles and the number of articles on each page
  _pagination.prototype.getNumberOfPages = function () {
    if (this.totalNumberArticles === 0 || this.pageSize === 0) {
      return 0;
    }
    return Math.ceil(this.totalNumberArticles / this.pageSize);
  };

  //used to se isMobile
  _pagination.prototype.isViewportMobile = function () {
    if (window.innerWidth < breakpoint) {
      return true;
    }
    return false;
  };

  //init function
  function _init(paginationTarget, totalNumberArticles, pageSize, currentPage, api) {
    var pagination = new _pagination(paginationTarget, totalNumberArticles, pageSize, currentPage, api);
    if (pagination.getNumberOfPages() <= 1) {
      //No pagination needed remove pagination
      pagination.target.querySelector(".card-group-footer").remove();
    } else {
      pagination.addPagination();
    }
    return pagination;
  }
  return {
    init: _init
  };
};
if (typeof exports !== 'undefined') {
  module.exports = paginationController;
}